import { render } from "./CustomsDeclarationSectionThree.vue?vue&type=template&id=906f0332&scoped=true"
import script from "./CustomsDeclarationSectionThree.vue?vue&type=script&lang=js"
export * from "./CustomsDeclarationSectionThree.vue?vue&type=script&lang=js"

import "./CustomsDeclarationSectionThree.vue?vue&type=style&index=0&id=906f0332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-906f0332"]])

export default __exports__